module.exports = __webpack_public_path__ + "static/img/image_charge.70cd57ad.png";